"use client";

import StudioForm from "./studio-form";
import { createStudio, updateStudio } from "./actions";

interface Studio {
  id: number;
  name: string;
  capacity: number | null;
  venue_id: number;
  status_id: number;
  equipment: any;
  created_at: string;
  updated_at: string;
  statuses: {
    id: number;
    name: string;
  };
  studio_infos: Array<{
    id: number;
    information: string;
    lang: string;
    features: any;
  }>;
  studio_medias?: Array<{
    id: number;
    url: string;
    type: string;
    is_primary: boolean;
  }>;
}

interface StudioFormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  venueId: number;
  studio?: Studio | null;
  onSuccess?: (studio: Studio) => void;
}

export function StudioFormDialog({
  isOpen,
  onClose,
  venueId,
  studio,
  onSuccess,
}: StudioFormDialogProps) {
  const handleSubmit = async (data: any) => {
    try {
      const result = studio
        ? await updateStudio(studio.id, data)
        : await createStudio(venueId, data);

      if (result.success && result.studio) {
        // Transform the studio to include status property for the card
        const transformedStudio = {
          ...result.studio,
          status: result.studio.statuses?.name || "inactive",
        };
        onSuccess?.(transformedStudio);
        onClose();
      } else {
        throw new Error(result.error || "Failed to save studio");
      }
    } catch (error) {
      console.error("Error saving studio:", error);
      throw error; // Re-throw to let the form handle the error
    }
  };

  return (
    <StudioForm
      studio={studio}
      venueId={venueId}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      mode={studio ? "edit" : "create"}
    />
  );
}
